package org.zest.insan_360_website.components.layouts
import org.zest.insan_360_website.data.localized

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.zest.insan_360_website.components.widgets.LanguageToggle
import org.zest.insan_360_website.components.widgets.LocalToast
import org.zest.insan_360_website.components.widgets.ToastType
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.page_states.UserPreferences

val authWordLibrary = LanguageSettings.AuthenticationPage
val authPageColor = Color.rgb(73, 209, 174)
val darkGreenColor = Color.rgb(12, 110, 99)
val lightGreenColor = Color.rgb(31, 193, 182)
val baseInputStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(2.5.cssRem)
            .border {
                width(2.px)
            }
            .borderRadius(0.5.cssRem)
            .fontFamily("FunnelDisplay")
            .fontSize(1.cssRem)
            .fontWeight(FontWeight.Light)
    }
}
val buttonColorStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(lightGreenColor)
    }

    hover {
        Modifier
            .backgroundColor(lightGreenColor.darkened(0.2f))
    }
}
val fontSizeBreakpoints = CssStyle {
    base {
        Modifier.fontSize(0.8.cssRem)
    }
    
    
}

@OptIn(ExperimentalComposeWebApi::class)
@Composable
@Layout
fun MainPageLayout(ctx: PageContext, content: @Composable () -> Unit) {
    val isJustVerified = ctx.route.params["verified"] == "true"
    val needToLogin = ctx.route.params["needToLogin"] == "true"
    val toast = LocalToast.current

    LaunchedEffect(isJustVerified) {
        if (isJustVerified) {
            toast.show(
                authWordLibrary.verifiedEmail.localized,
                ToastType.SUCCESS
            )
        }
        if (needToLogin) {
            toast.show(
                authWordLibrary.loginRequired.localized,
                ToastType.INFO
            )
        }
    }
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
            .padding(
                topBottom = 5.cssRem,
                leftRight = 1.cssRem
            )
            .backgroundColor(authPageColor),
        contentAlignment = Alignment.Center
    ) {
        LanguageToggle(authPageColor, 1.5, 1.5)
        content()
    }
}

